module.exports = __webpack_public_path__ + "static/media/13_nature.7b66ce23.jpg";